import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, Getter } from 'vuex-class';
import { CART_CALC_ORDER, CART_PREPARE_ORDER, CART_DISPLAY, CART_EXPAND, ORDER_PATCH } from '@/apps/cart/store/types';
import { API_ERROR_SET } from '@/apps/core/store/types';
import { getFullName, getPlatformType } from '@/lib/utils';

/** Mixin for finishing orders from different pages within the configurator. */
@Component
export default class OrderFinisherMixin extends Vue {
  @Getter restaurantId;
  @Getter orderType;
  @Getter order;
  @Getter guestAccountData;
  @Getter getPreparedItems;
  @Getter authUser;
  @Getter getNotAuthUserData;
  @Action(CART_CALC_ORDER) cartCalcOrder;
  @Action(CART_PREPARE_ORDER) cartPrepareOrder;
  @Action(ORDER_PATCH) updateOrder;
  @Action(CART_DISPLAY) displayCart;
  @Action(CART_EXPAND) cartExpand;
  @Action(API_ERROR_SET) setApiError;

  /** Finishes order and redirects the user to cart. */
  async finishOrder() {
    try {
      if (this.order && this.order.promotionCodeApplied && this.isKioskPlatform) {
        const promoCode = this.order.promotionCodeApplied;
        const tempUserData =
          this.authUser ||
          this.getNotAuthUserData ||
          this.guestAccountData;

        const order = {
          restaurant_id:  this.restaurantId,
          pickup_type:    this.orderType,
          recipient_name: getFullName(tempUserData),
          first_name:     tempUserData.firstName,
          last_name:      tempUserData.lastName,
          phone:          tempUserData.phone,
          email:          tempUserData.email,
          device_type:    getPlatformType(),
          items:          this.getPreparedItems,
          promotion_code: promoCode,
        };

        await this.cartCalcOrder({ promoCode });
        await this.updateOrder(order);
      } else {
        await this.cartCalcOrder();
      }
      this.redirectToMenuAndOpenCart();
    } catch (err) {
      this.setApiError({ detail: err.response.data.detail });
      throw new Error(err);
    }
  }

  /** Redirects user to cart. */
  redirectToMenuAndOpenCart() {
    this.$router.push({ name: 'menu' });
    this.displayCart(true);

    if (this.isMobilePlatform) {
      this.cartExpand();
    }
  }
}



// WEBPACK FOOTER //
// ./src/apps/configurator/mixins/order-finisher-mixin.js